
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"200","height":"200","viewBox":"0 0 52.917 52.917","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.335 11.505L8.198 26.457l14.137 14.954 3.513-3.322-11-11.632 11-11.63-3.513-3.322z"}}),_c('path',{attrs:{"d":"M13.457 24.041v4.833h32.384v-4.833z"}})])
          )
        }
      }
    